import { render, staticRenderFns } from "./OfferPositionBoilerplates.vue?vue&type=template&id=2cf3155c"
import script from "./OfferPositionBoilerplates.vue?vue&type=script&lang=js"
export * from "./OfferPositionBoilerplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports